import { render } from "./ArchiveArrowUp.vue?vue&type=template&id=6c3352de"
import script from "./ArchiveArrowUp.vue?vue&type=script&lang=js"
export * from "./ArchiveArrowUp.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/ArchiveArrowUp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c3352de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c3352de', __exports__)) {
    api.reload('6c3352de', __exports__)
  }
  
  module.hot.accept("./ArchiveArrowUp.vue?vue&type=template&id=6c3352de", () => {
    api.rerender('6c3352de', render)
  })

}


export default __exports__